import { ForwardedRef, InputHTMLAttributes, ReactNode, forwardRef } from "react"
import {
  SInput,
  SInputWrapper,
  SLeftContentWrapper,
  SRightContentWrapper,
} from "../../acquisitionForm/AcquisitionForm.styled"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { CSSProp, theme } from "../../../../../styles/stitches.config"
import { Check, Cross, Info } from "../../../../../images/xd/icons"
import { Div } from "../../../../../components/div/Div"
import { FormError } from "./Form"
import { Flex } from "../../../../../components/flex/Flex"
import Text from "../../../../../components/Text"

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  leftContent?: ReactNode
  success?: boolean
  error?: string
  rightContentCSS?: CSSProp
  css?: CSSProp
}

function FormInputInner(
  { children, leftContent, success, error, rightContentCSS, css, ...props }: InputProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  return (
    <Div>
      <Spacer size={theme.space.s3_5} />
      <SInputWrapper>
        <SInput
          ref={ref}
          css={css}
          state={success ? "success" : error ? "error" : "default"}
          hasLeftContent={!!leftContent}
          {...props}
        >
          {children}
        </SInput>

        {leftContent && <SLeftContentWrapper>{leftContent}</SLeftContentWrapper>}
        <SRightContentWrapper css={rightContentCSS}>
          {success && <Check color={theme.colors.successes.value} width={18} height={18} />}
          {!!error && <Cross color={theme.colors.errors.value} width={18} height={18} />}
        </SRightContentWrapper>
      </SInputWrapper>

      {error && (
        <>
          <Spacer size={theme.space.s1_5} />
          <FormError>{error}</FormError>
        </>
      )}
    </Div>
  )
}

export const FormInput = forwardRef(FormInputInner)

type DisclaimerProps = {
  // TODO transform into children composition pattern
  label: ReactNode
  labelCSS?: CSSProp
}

export function InputDisclaimer(props: DisclaimerProps) {
  const { label, labelCSS } = props
  return (
    <Flex align="center" css={{ gap: theme.space.s4 }}>
      <Info
        width={theme.space.s6.value}
        height={theme.space.s6.value}
        color={theme.colors.textsAlt.value}
        style={{ flexShrink: 0 }}
      />
      <Text
        type="textsSmall"
        color="textsAlt"
        css={{
          fontSize: theme.fontSizes.xSmall,
          lineHeight: theme.sizes.s3_5,
          ...labelCSS,
        }}
      >
        {label}
      </Text>
    </Flex>
  )
}
